import { useCallback } from 'react';
import { Metrics } from '../utils/metrics';
import { captureException } from '../utils/sentryUtils';
import { assertApprovalDataResolved } from '../utils/assertApprovalDataResolved';
import { toApprovalData } from '../utils/approvalResponseAdapters';
import { useCancelApprovalMutation } from '../../__generated__/chirp/com/hubspot/product/approvals/rpc/ApprovalsRpc.hooks';
import { GET_LATEST_APPROVAL_QUERY } from '../../__generated__/chirp/com/hubspot/product/approvals/rpc/ApprovalsRpc.dfc.new';
import { APPROVAL_TYPE_TO_OBJECT_TYPE_ID } from 'ui-product-approvals-common/constants/approvalTypeIds';
export const useCancelApproval = ({
  approvalType,
  approvalAction,
  approvableObjectId,
  usersRecord,
  agentsRecord,
  resolvedData
}) => {
  const [cancelApprovalMutation] = useCancelApprovalMutation();
  const cancel = useCallback(note => {
    const validated = assertApprovalDataResolved('useCancelApproval', resolvedData, approvableObjectId);
    return cancelApprovalMutation({
      variables: {
        approvalId: validated.resolvedData.id,
        note
      },
      update: (cache, {
        data: mutationData
      }) => {
        var _mutationData$result;
        const approvalData = mutationData === null || mutationData === void 0 || (_mutationData$result = mutationData.result) === null || _mutationData$result === void 0 ? void 0 : _mutationData$result.approval;
        if (approvalData) {
          cache.writeQuery({
            query: GET_LATEST_APPROVAL_QUERY,
            variables: {
              approvalTypeId: APPROVAL_TYPE_TO_OBJECT_TYPE_ID[approvalType],
              approvalAction,
              approvableObjectId: validated.approvableObjectId
            },
            data: {
              result: {
                approval: approvalData
              }
            }
          });
        }
      }
    }).then(result => {
      var _result$data;
      Metrics.counter('request-recalled').increment();
      const approval = result === null || result === void 0 || (_result$data = result.data) === null || _result$data === void 0 || (_result$data = _result$data.result) === null || _result$data === void 0 ? void 0 : _result$data.approval;
      if (approval) {
        return toApprovalData(approval, usersRecord, agentsRecord, approvalType, approvalAction);
      } else {
        throw new Error('cancelApproval succeeded but returned no approval data');
      }
    }).catch(error => {
      captureException(error, {
        extra: {
          fingerprint: 'useApprovalData-cancel',
          approvalType,
          approvalAction,
          approvalId: validated.resolvedData.id
        }
      });
      throw error;
    });
  }, [cancelApprovalMutation, resolvedData, usersRecord, agentsRecord, approvalType, approvalAction, approvableObjectId]);
  return cancel;
};